var map = {
	"./1.jpeg": 4281,
	"./2.jpeg": 6024,
	"./3.jpeg": 4543,
	"./4.jpeg": 2438,
	"./5.jpeg": 3757,
	"./6.jpeg": 5468,
	"./7.jpeg": 723,
	"./8.jpeg": 9130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8032;